export default {
  "widget.defaultTitle": "Chat with us",
  "widget.defaultSubtitle": "We're here to help",
  "widget.defaultGreeting": "Hello! How can we help you today?",
  "chat.close": "Close chat",
  "chat.open": "Open chat",
  "chat.expand": "Expand chat",
  "chat.collapse": "Collapse chat",
  "chat.conversationEnded": "This conversation has ended",
  "chat.startNew": "Start New Conversation",
  "chat.poweredBy": "Powered by",
  "chat.conversationClosed": "Conversation Closed",
  "chat.aiLabel": "AI assistant",
  "input.placeholder": "Type a message...",
  "input.send": "Send message",
  "error.sendFailed": "Couldn't send your message. Please try again in a moment.",
  "error.messageTooLong": "Your message is too long. Please shorten it and try again.",
  "chat.teamMember": "A team member",
  "chat.agentJoined": "{name} joined the chat",
  "chat.agentLeft": "{name} left the chat",
  "chat.agentReturnedToAi": "{name} left the chat. You're chatting with the AI assistant again.",
  "availability.open": "Open now",
  "availability.backAt": "Back {when}",
  "availability.closed": "Away right now",
  "waiting.title": "Waiting for a person",
  "waiting.typical": "Usually replies in {time}",
  "waiting.alerted": "We've alerted the team.",
  "waiting.closed": "The team is back {when}. The AI assistant can keep helping until then.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} h",
  "contact.prompt": "Leave your email and we'll send the team's reply there if you've left.",
  "contact.label": "Email",
  "contact.placeholder": "you@example.com",
  "contact.submit": "Notify me",
  "contact.consent": "We'll only use your email to reply to this conversation.",
  "contact.saved": "Thanks! If you've left when the team replies, we'll email you.",
  "contact.failed": "Couldn't save your email. Please check it and try again.",
  "input.attach": "Attach a photo or PDF",
  "error.fileTooLarge": "That file is too large. Photos and PDFs up to 10 MB.",
  "error.fileType": "You can send photos (JPG, PNG, GIF, WebP) or PDFs.",
  "error.fileFailed": "Couldn't send your file. Please try another one.",
  "attachment.photo": "Photo",
  "attachment.file": "File",
  "attachment.sending": "Sending...",
  "error.verificationFailed": "We couldn't verify your message. Please refresh the page and try again.",
  "challenge.label": "Security check",
  "challenge.prompt": "Quick security check before we send your message.",
  "csat.defaultQuestion": "How would you rate the support you received today?",
  "csat.thankYou": "Thanks for your feedback!",
} as const;
